import {FiTrash} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {SubscriptionEmailDomainType} from "@/lib/types/statuspages.ts";
import {DeleteEmailDomainsActionButton} from "@/pages/statuspages/tabs/subscribers/components/allow-block-list/actions/DeleteEmailDomainsActionButton.tsx";

export interface EmailDomainsActionBarProps {
  domainIds: number[];
  domainType: SubscriptionEmailDomainType;
  onDeleteSuccess: () => void;
}

export const EmailDomainsActionBar = ({domainType, domainIds, onDeleteSuccess}: EmailDomainsActionBarProps) => {
  return (
    <>
      <DeleteEmailDomainsActionButton
        domainIds={domainIds}
        domainType={domainType}
        onSuccess={onDeleteSuccess}
        isBulkAction={true}
        variant="tableCrown"
      >
        <Icon icon={FiTrash} />
        Delete
      </DeleteEmailDomainsActionButton>
    </>
  );
};
